import { combineReducers } from 'redux';
import CefApplicationReducer from "./Reducers/CefApplicationReducer";
import CefProgressReducer from "./Reducers/CefProgressReducer";
import PreferencesReducer from "./Reducers/PreferencesReducer";
var appReducer = combineReducers({
  CefApplication: CefApplicationReducer,
  CefProgress: CefProgressReducer,
  Preferences: PreferencesReducer
});
export var rootReducer = function rootReducer(state, action) {
  return appReducer(state, action);
};